import { Grid } from '@mui/material';
import LoadingSkeleton from 'src/components/common/LoadingSkeleton';
import WhiteBoxContent from 'src/components/common/WhiteBoxContent';

const ProductBreakdownSkeleton = () => {
  return (
    <Grid container spacing={1}>
      {Array(9)
        .fill(0)
        .map((_, i) => (
          <Grid xs={4} key={i} item>
            <WhiteBoxContent>
              <LoadingSkeleton count={6} />
            </WhiteBoxContent>
          </Grid>
        ))}
    </Grid>
  );
};

export default ProductBreakdownSkeleton;
